import OrdersBoard from './rah-kala/OrdersBoard';
import UniPage from './UniPage';
// import UsersManager from './user/UsersManager';
// import Questionnare from './design-ques/Questionnare';
// import LikertScale from './design-ques/LikertScale';
// import FillQuestionnare from './fill-ques/FillQuestionnare';
// import QuestionType from './design-ques/QuestionType';

import { isMobile } from 'react-device-detect';

const stl = {
    marginTop: isMobile ? '0.5rem' : '1rem',
    width: 'auto', // isMobile ? 'auto' : '70%',
    padding: isMobile ? '0.5rem' : '1rem',
    background: 'whitesmoke',
    borderRadius: isMobile ? '0.5rem' : '1rem'
};

class CommandManager {
    static key = 1;
    static componentsMap = [
        { key: 'MoneyInOut', component: prp => <p>TEST</p> },
        // { key: 'UsersManager', component: prp => <UsersManager style={stl} {...prp} /> },
        // { key: 'Questionnare', component: prp => <Questionnare style={stl} {...prp} /> },
        // { key: 'FillQuestionnare', component: prp => <FillQuestionnare style={stl} {...prp} /> },
        // { key: 'QuestionType', component: prp => <QuestionType style={stl} showDeleteButton showApplyButton {...prp} /> },
        // { key: 'LikertScale', component: prp => <LikertScale style={stl} showDeleteButton showApplyButton {...prp} /> },
        // {
        //     key: 'OrdersBoard', component: prp => (
        //         <OrdersBoard style={stl} showDeleteButton showApplyButton
        //             userRole={window.user?.role} userId={window.user?.idAtRole ?? 0}
        //             userName={window.user?.userName}
        //             //userText={window.user?.fullname ?? '&nbsp;'}
        //             // onEdit={(loadOrder, tempCol) => {
        //             //     this.setState({
        //             //         loadOrder, tempCol, mode: 'edit', bodyKey: this.state.bodyKey + 1
        //             //     });
        //             // }}
        //             // onAddNewOrderClicked={() => {
        //             //     this.setState({
        //             //         loadOrder: {}, tempCol: {}, mode: 'new', bodyKey: this.state.bodyKey + 1
        //             //     });
        //             // }}

        //             // onLogoff={() => {
        //             //     window.user = { id: 0 };
        //             //     this.setState({ mode: 'logon' });
        //             // }}
        //             {...prp}
        //         />)
        // },
    ];

    static getComponentNames() {
        return CommandManager.componentsMap.map(x => x.key);
    }

    static ComponentOf(item, additionalProps) {
        return (
            <UniPage ref={el => window.uniPage = el}
                key={'comng_' + ++CommandManager.key}
                menuItem={item}
                additionalProps={additionalProps}
            />
        );
    }

    static processP(item, additionalProps) {
        console.log('== processing command, item=', item, 'additional props=', additionalProps);

        return new Promise((resolve, reject) => {
            switch (item.targetType) {
                case 'table':
                case 'urltable':
                case 'component':
                case 'ssc':
                    //window.setInnerBody(CommandManager.ComponentOf(item, additionalProps), resolve);
                    resolve?.(CommandManager.ComponentOf(item, additionalProps));
                    return;
                case 'script':
                    eval(item.targetDetails);
                    resolve?.();
                    return;
                case 'webpage':
                    document.location = item.targetDetails;
                    resolve?.();
                    return;
                case 'sub':
                    resolve?.();
                    return;
                default:
                    reject?.(`Invalid target: ${item.targetType}, details: ${item.targetDetails}`);
                    return;
            }
        });
    }
}

export { stl };
export default CommandManager;
